export default __webpack_public_path__ + "images/0aa587ce2fe44a8200efa8356a7d3826.png";